import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TOASTR } from '../../constants/toastr';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private config = {
    closeButton: true,
    disableTimeOut: false,
    enableHtml: true,
    easing: TOASTR.ANIMATION,
    timeOut: TOASTR.TIMEOUT,
    positionClass: TOASTR.POSITION,
  };

  private defaultTiming = {
    delay: TOASTR.DELAY,
    duration: TOASTR.TIMEOUT,
  };

  public typeError = 'Toastr service not defined properly';

  constructor(public toastrService: ToastrService) {}

  show(
    type: string,
    title: string,
    message?: string,
    timing?: { delay?: number; duration?: number },
  ): void {
    const icon = TOASTR.ICONS[`${type.toUpperCase()}`];
    const delay = timing ? timing.delay : this.defaultTiming.delay;
    this.config.timeOut = timing ? timing.duration : this.defaultTiming.duration;

    setTimeout(() => {
      if (this.toastrService[type]) {
        this.toastrService[type](this.buildMessage(icon, title, message), ``, this.config);
      } else {
        console.error(this.typeError, this.toastrService);
      }
    }, delay);
  }

  info(message: string, title?: string, timing?: { delay?: number; duration?: number }): void {
    this.show(TOASTR.TYPE.INFO, title, message, timing);
  }

  success(message: string, title?: string, timing?: { delay?: number; duration?: number }): void {
    this.show(TOASTR.TYPE.SUCCESS, title, message, timing);
  }

  error(message: string, title?: string, timing?: { delay?: number; duration?: number }): void {
    this.show(TOASTR.TYPE.ERROR, title, message, timing);
  }

  warning(message: string, title?: string, timing?: { delay?: number; duration?: number }): void {
    this.show(TOASTR.TYPE.WARNING, title, message, timing);
  }

  buildMessage(icon: string, title?: string, message?: string): string {
    const parsedTitle = title ? `<strong>${title}</strong>` : '';
    return `<i class="${icon}"></i> ${parsedTitle} ${message}`;
  }

  clear(): void {
    this.toastrService.clear();
  }
}
